import { Injectable, ModuleWithProviders, NgModule, inject } from '@angular/core';
import {
  Translation,
  TRANSLOCO_CONFIG,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule,
  DefaultFallbackStrategy,
  DefaultInterceptor,
  DefaultMissingHandler,
  provideTranslocoFallbackStrategy,
  provideTranslocoInterceptor,
  provideTranslocoLoader,
  provideTranslocoMissingHandler,
} from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { TranslocoLocaleModule, provideTranslocoLocale } from '@jsverse/transloco-locale';
import { Observable } from 'rxjs';
import { HttpWithoutInterceptorService } from '../services';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFl from '@angular/common/locales/de-BE';

registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeIt);
registerLocaleData(localeDe);
registerLocaleData(localeEs);
registerLocaleData(localeFl);

@Injectable()
export class TranslocoHttpLoaderSmartSequence implements TranslocoLoader {
  private _httpWithoutInterceptorService = inject(HttpWithoutInterceptorService);

  getTranslation(lang: string): Observable<Translation> {
    return this._httpWithoutInterceptorService.get<Translation>(`assets/i18n/${lang}.json`);
  }
}

@NgModule({
  imports: [TranslocoModule],
  exports: [TranslocoModule, TranslocoLocaleModule],
  providers: [],
})
export class TranslocoModuleSmartSequence {
  static forRoot(params: { production: boolean }): ModuleWithProviders<TranslocoModuleSmartSequence> {
    return {
      ngModule: TranslocoModuleSmartSequence,
      providers: [
        provideTranslocoLocale({
          langToLocaleMapping: {
            en: 'en-US',
            fr: 'fr-FR',
            it: 'it-IT',
            es: 'es-ES',
            de: 'de-DE',
            fl: 'fl-FL',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            fr_FR_tutoiement: 'fr-FR',
          },
        }),
        provideTranslocoMessageformat(),
        {
          provide: TRANSLOCO_CONFIG,
          useValue: translocoConfig({
            availableLangs: ['en', 'fr', 'it', 'de', 'es', 'fl', 'fr_FR_tutoiement'],
            reRenderOnLangChange: true,
            defaultLang: 'fr',
            fallbackLang: 'en',
            missingHandler: {
              useFallbackTranslation: true,
              logMissingKey: false,
            },
            prodMode: params.production,
            flatten: {
              aot: params.production,
            },
          }),
        },
        provideTranslocoMessageformat({ locales: ['fr-FR', 'en-EN'] }),
        provideTranslocoLoader(TranslocoHttpLoaderSmartSequence),
        provideTranslocoMissingHandler(DefaultMissingHandler),
        provideTranslocoInterceptor(DefaultInterceptor),
        provideTranslocoFallbackStrategy(DefaultFallbackStrategy),
      ],
    };
  }
}
